<template>
  <div class="popup_wrap" style="width:1000px; height:700px;">
    <button type="button" class="layer_close" @click="$emit('close')">close</button>
    <div class="popup_cont">
      <h1 class="page_title">House B/L Information</h1>
      <div class="content_box mt10" id="frmReq">
        <table class="tbl_search">
          <colgroup>
            <col width="200px">
            <col>
            <col width="100px">
            <col>
            <col width="100px">
            <col>
            <col width="100px">
          </colgroup>
          <tbody>
            <tr>
              <th>House B/L No.</th>
              <td>
                <input
                  type="text"
                  class="wid200"
                  v-model="fwdrBlNo"
                  readonly
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="content_box mt10">
        <table class="tbl">
          <tbody>
            <tr>
              <td>
                <div class="tab">
                  <ul>
                    <li class="on" id="tab1" @click="selectTab(1)"><a href="javascript:void(0)">Shipper</a></li>
                    <li id="tab2" @click="selectTab(2)"><a href="javascript:void(0)">Cargo</a></li>
                    <li id="tab3" @click="selectTab(3)"><a href="javascript:void(0)">Body Detail</a></li>
                  </ul>
                </div>
                <div class="content_box" v-show="tapState === 1">
                  <house-bl-shipper ref="shipping" :parent-info="parentParam"></house-bl-shipper>
                </div>
                <div class="content_box" v-show="tapState === 2">
                  <house-bl-cargo ref="cargo" :parent-info="parentParam"></house-bl-cargo>
                </div>
                <div class="content_box" v-show="tapState === 3">
                  <house-bl-container ref="container" :parent-info="parentParam"></house-bl-container>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mt10 text_center">
        <a class="button blue lg" href="javascript:void(0)" @click="gethouseBlInfo()">{{ $t('msg.ONEX050G020.027') }}</a> <!-- 저장 -->
        <a class="button gray lg" href="javascript:void(0)" @click="$emit('close')">{{ $t('msg.ONEX060P012.068') }}</a> <!-- 닫기 -->
      </div>
    </div>
  </div>
</template>

  <script>
  import { rootComputed } from '@/store/helpers'
  import bsaExternalVariables from '@/api/rest/bsa/bsaExternalVariables'
  import bsaCommonInfo from '@/api/rest/bsa/bsaCommonInfo'
  import EBreadcrumbs from '@/components/common/EBreadcrumbs'
  import JSZip from 'jszip'
  import ETabItem from '@/components/common/ETabItem'
  import ETab from '@/components/common/ETab'

  window.JSZip = window.JSZip || JSZip

  export default {
    name: 'HouseBlpop',
    components: {
      EBreadcrumbs,
      ETabItem,
      ETab,
      EDatePicker: () => import('@/components/common/EDatePicker'),
      CstSearchListPop: () => import('@/pages/cp/popup/CstSearchListPop'),
      'house-bl-shipper': () => import('@/pages/trans/WorkingHouseBlShppierInfo.vue'),
      'house-bl-cargo': () => import('@/pages/trans/WorkingHouseBlCargoInfo.vue'),
      'house-bl-container': () => import('@/pages/trans/WorkingHouseBlContainerInfo.vue')
    },
    props: {
      parentInfo: {
        type: Object,
        default: () => {
          return []
        }
      }
    },
    data: function () {
      return {
        customComponent: null,
        // parentInfo: {
        //   position: '',
        //   ships: [],
        //   bkgShipper: []
        // },
        tapState: 1,
        listTab1: [{}],
        listTab2: [{}],
        listTab3: [{}],
        list: [{}],
        param: {
          yearWeek: '',
          porCtr: '',
          porPlc: '',
          dlyCtr: '',
          dlyPlc: '',
          bkgShipper: '',
          bkgShipperList: [],
          bkgShipLength: 0,
          lastBkgShip: ''
        },
        tab1Param: {
          yearWeek: '',
          porPlc: '',
          dlyPlc: ''
        },
        tab2Param: {
          yearWeek: '',
          porPlc: '',
          dlyPlc: ''
        },
        tab3Param: {
          yearWeek: '',
          porPlc: '',
          dlyPlc: ''
        },
        subParam: {
          yearWeek: '',
          porPlc: '',
          dlyPlc: '',
          bkgShipper: ''
        },
        countryList: [],
        countryList2: [],
        harborList: [],
        harborList2: [],
        yearWeekList: [],
        yearWeekSearchList: [],
        poptSearchKeyword: '',
        currentYearWeek: '',
        send: {
          keyInput: {
            yearWeek: []
          }
        },
        fwdrBlNo: '',
        parentParam: {}
      }
    },
    computed: {
      ...rootComputed
    },
    created () {
      this.fwdrBlNo = this.parentInfo.houseBlList.fwdrBlNo
      this.parentParam = JSON.parse(JSON.stringify(this.parentInfo))
    },
    mounted: function () {
      const $vm = this
      window.func = this

      // 처음 열릴 탭 할당
      if (this.parentInfo.kind === 'shipping') {
        this.selectTab(1)
      } else if (this.parentInfo.kind === 'cargo') {
        this.selectTab(2)
      } else {
        this.selectTab(3)
      }
    },
    methods: {
      gethouseBlInfo () {
        let shippingInfo = this.$refs.shipping.sendShippingInfo()
        let cargoInfo = this.$refs.cargo.sendCargoInfo()
        let containerInfo = this.$refs.container.sendContainerInfo()
        let houseBlInfo = {}

        console.log('shippingInfo @@@@@ ', shippingInfo)
        console.log('cargoInfo @@@@@ ', cargoInfo)
        console.log('containerInfo @@@@@ ', containerInfo)

        houseBlInfo = { ...shippingInfo, ...cargoInfo, ...containerInfo }

        this.$emit('selectFunc', { houseBlInfo, idx: this.parentInfo.idx })
        this.$emit('close')
      },
      openAlert: function (msg) {
        let obj = {
          alertType: 'simple',
          onClose: this.closeFun,
          customCloseBtnClass: 'button blue lg simplert-test1',
          customCloseBtnText: this.$t('cp.COMMON.005'),
          useIcon: false,
          customClass: 'simple_alert',
          message: msg,
          type: 'info'
        }
        this.$ekmtcCommon.alert(obj)
      },
      selectTab (tab) {
        $('.tab li').removeClass('on')

        $('#tab' + tab).addClass('on')

        this.tapState = tab
      }
    }
  }
  </script>
  <style>

    .excelTitle {
      font-size: 18px;
      font-weight: bold;
    }

    .cp-td-button {
    width: 100%;
    height: 24px !important;
    text-align: left;
    box-sizing: border-box;
    padding: 0 5px !important;
    color: #000000 !important;
    border: solid 1px #cecece !important;
    border-radius: 0px !important;
    background: url('data:image/png;base64,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') no-repeat center right;
  }

  .cp-td-button.disabled {
    border: 1px solid #e1e1e1 !important;
    color: #b7b7b7 !important;
    background: #f9f9f9 url('data:image/png;base64,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')  no-repeat center right;
  }

  .cp-td-button:active {
    border: 1px solid #003193 !important;
    color: #003193 !important;
  }

  .cp-td-button .cp-short-text {
    display: block;
    width: calc(100% - 16px);
    height: inherit;
    overflow: hidden;
    white-space: nowrap;
  }

  .cp-grid .cp-scroll::-webkit-scrollbar-track {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .cp-scroll::-webkit-scrollbar-thumb {
    background-color: #babac0;
    border-radius: 10px;
    border: 5px solid #ffffff00;
  }

  .cp-scroll::-webkit-scrollbar-button {
    display: none;
  }

  .cp-parentnode > h2 {
    margin-top: 8px !important;
    margin-bottom: 0px !important;
  }

  .cp-unitbox {
    position: absolute;
    z-index: 10;
    min-width: 150px;
    border: 1px solid #b4b4b4;
    background-color: #ffffff;
    box-shadow: 0px 12px 26px 6px #a7a7a780;
    user-select: none;
  }

  .cp-unitbox.cp-popt {
    width:150px;
    border-radius: 10px;
  }

  .cp-unitbox > * {
    position: relative;
  }

  .cp-psel {
    text-align: left;
    line-height: 24px;
    cursor: default;
    height: 24px;
    padding: 0 20px 0 5px;
    border: solid 1px #cecece;
    font-size: 13px;
    letter-spacing: -1px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAzIDc5LjE2NDUyNywgMjAyMC8xMC8xNS0xNzo0ODozMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjEgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkQ2NUMwQjRFRjU4MzExRUJCNUJEQzFCQTJGRjAyRTYwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkQ2NUMwQjRGRjU4MzExRUJCNUJEQzFCQTJGRjAyRTYwIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RDY1QzBCNENGNTgzMTFFQkI1QkRDMUJBMkZGMDJFNjAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RDY1QzBCNERGNTgzMTFFQkI1QkRDMUJBMkZGMDJFNjAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4h6VXxAAAATlBMVEWPj4/o6OiQkJDMzMzOzs7j4+Oamprk5OSSkpKOjo6NjY3Q0NDl5eXHx8fIyMjPz8/m5ubNzc2RkZHLy8vS0tLJycnV1dXn5+f////////PBEJmAAAAGnRSTlP/////////////////////////////////ABQiANoAAABISURBVHjaYpDEARiGlwQvJ7sECLBy8aFKSIgyCADFeRiEJdAkJJiZGCXEGQQlMCQkWDjEhPglsEhIcLOJSGBIDPvQxQQAAQYA98E2rkH8+7gAAAAASUVORK5CYII=) no-repeat right 50%;
    width: 100%;
    font-weight: 300;
    vertical-align: middle;
    font-family: 'Noto Sans KR', sans-serif;
    word-wrap: normal;
    text-transform: none;
    margin: 0;
  }

  .cp-psel:disabled {
    border: 1px solid #e1e1e1;
    color: #b7b7b7 !important;
    background: #f9f9f9 url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAzIDc5LjE2NDUyNywgMjAyMC8xMC8xNS0xNzo0ODozMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjEgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkUyQ0M3MDRDRjU4MzExRUI4QURCRTM4RDNCNTU3RTUzIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkUyQ0M3MDRERjU4MzExRUI4QURCRTM4RDNCNTU3RTUzIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RTJDQzcwNEFGNTgzMTFFQjhBREJFMzhEM0I1NTdFNTMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RTJDQzcwNEJGNTgzMTFFQjhBREJFMzhEM0I1NTdFNTMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4Bnl+bAAAAKlBMVEXPz8/k5OTOzs7t7e3u7u7s7Ozl5eXm5ubj4+PS0tLn5+fi4uL29vb///9dVj3DAAAADnRSTlP/////////////////AEXA3MgAAABESURBVHja3NDLAYAgEAPRsHwWdei/XfCoqw0wx7xbNH7SXnBZ5a5afwLd8tqzEi8gqVDWHoCmU40PwA8nwPbvxqYAAwAEZRw7sBHRUAAAAABJRU5ErkJggg==) no-repeat right 50% !important;
  }

  .cp-psel::placeholder {
    color: #000000;
  }

  .cp-psel:disabled::placeholder {
    color: #b7b7b7;
  }

  .cp-psel:focus {
    border-color: #0641b8 !important;
    outline: none;
  }

  .cp-popt--close {
    display: none;
  }

  .cp-popt .cp-ul {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .cp-li-header {
    padding: 8px 13px 8px 11px;
  }

  .cp-li-header--condition {
    min-height: 30px;
    font-size: 13px;
    cursor: pointer;
    border-bottom: 1px solid #cecece;
  }

  .cp-realfiltering .cp-li-header {
    background-color: #ffffff;
  }

  .cp-ul {
    max-height: 300px;
    text-align: left;
    font-weight: 400;
    font-size: 13px;
    text-align: left;
    user-select: none;
  }

  .cp-ul--hide {
    height: 1px;
    border-top: 1px solid #cecece;
    padding-right: 15px;
  }

  .cp-ul--hide .cp-li {
    height: inherit;
    color: #ffffff00;
  }

  .cp-ul--blank {
    background-color: #f6f6f6;
  }

  .cp-li {
    white-space: nowrap;
    height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    background-color: #ffffff;
  }

  .cp-ul--plc .cp-li {
    padding: 0px 11px 0px 11px;
  }

  .cp-li > span {
    position: relative;
    left: 5px;
  }

  .cp-popt .cp-li:hover,
  .cp-ul--ctr:not(:hover) .cp-li--selected,
  .cp-ul--plc .cp-li--selected,
  .cp-grid .cp-ul:not(:hover) .cp-li--selected,
  .cp-ul--cond .cp-li:hover,
  .cp-ul--vals .cp-li:hover,
  .cp-ul--cond .cp-li--selected,
  .cp-ul--vals .cp-li--selected {
    background-color: #eaebf2 !important;
    color: #075bb9 !important;
  }

  .cp-li--dummy {
    pointer-events: none;
    height: 1px;
  }

  .cp-pchkbox--disabled {
    cursor: default;
    pointer-events: none;
  }

  .cp-pchkbox--disabled:before {
    background-position: 0 -54px !important;
  }

  .cp-pchkbox--hide {
    display: none !important;
  }

  .cp-pchkbox--selected:before {
    background-position: 0 -18px !important;
  }

  .cp-li--hide {
    display: none;
  }

  .tbl { width:100%; border-bottom:1px solid #e1e3eb; table-layout:fixed }
  .tbl th { padding:4px 5px 4px 10px; background:#f6f9ff; color:#075bb9; }
  .tbl td { padding:4px 10px 4px 10px;}

  </style>
